var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-multiselect',{attrs:{"options":_vm.times,"label":"label","track-by":"label","showLabels":false,"placeholder":"","open-direction":_vm.openDirection,"disabled":_vm.disabled,"searchable":true},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }